import React from 'react';

const HouseHoldFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.1788 6.32016C11.8296 6.97099 11.8296 8.02599 11.1788 8.67682C10.5279 9.32766 9.47294 9.32766 8.82211 8.67682C8.17128 8.02599 8.17128 6.97099 8.82211 6.32016C9.47294 5.66932 10.5279 5.66932 11.1788 6.32016"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.41667 5.83203V9.16536" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5837 5.83203V9.16536" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.99967 17.4987V13.332" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.99967 13.332L8.33301 14.9987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.6667 14.9987L10 13.332" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.66667 12.5H4.16667C3.24583 12.5 2.5 11.7542 2.5 10.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V10.8333C17.5 11.7542 16.7542 12.5 15.8333 12.5H13.3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HouseHoldFilterIcon;
